module.exports = __webpack_public_path__ + "static/media/branding-img24.ddb78218.jpg";